export const userAgent =
  typeof window === 'undefined' ? '' : navigator.userAgent;

// ArcSite UA
// example: ArcSite@1.2.3
export const arcsiteVersionPattern = /ArcSite@([\d.]+)?/i;

// ArcSite Platform
// enum:
// platform@android
// platform@windows
export const arcsitePlatformPattern = /platform@([\w.]+)?/i;

export const mobilePattern = /mobile|mobi|wap|simulator|iphone|ipad|android/gi;
export const ardVersionPattern = /Android\s+([\d.]+);/i;
export const iosPattern = /(iphone|ipod|ipad)/i;
